/**
 * Where a horizontally scrolling strip must sit to show one of its items.
 *
 * The strip does not measure its children: the items of the strips that use
 * this are near enough the same width that dividing the content evenly puts
 * the wanted one on screen, and an exact measurement per item would cost a
 * layout pass per item on both platforms. It centres the item where it can
 * and clamps at the ends, so the first and last items sit flush rather than
 * leaving a gap.
 */
export function centeredScrollOffset({
  index,
  count,
  contentWidth,
  viewportWidth,
}: {
  index: number;
  count: number;
  contentWidth: number;
  viewportWidth: number;
}): number {
  const overflow = contentWidth - viewportWidth;
  if (!(overflow > 0) || count <= 0 || index < 0) return 0;
  const itemWidth = contentWidth / count;
  const center = (index + 0.5) * itemWidth;
  return Math.min(Math.max(center - viewportWidth / 2, 0), overflow);
}
